/**
 * DeleteUserModal - Modal for delete user confirmation
 */
export default function DeleteUserModal({
  show,
  onClose,
  user,
  onDelete,
  loading,
  isBulk = false,
  selectedCount = 0,
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
      <div className="bg-card border border-red-700 rounded-xl max-w-md w-full p-6 space-y-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-red-500/10 border border-red-500/20 rounded-lg flex items-center justify-center">
            <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-foreground">
            {isBulk ? `Delete ${selectedCount} Users?` : "Delete User?"}
          </h3>
        </div>
        
        <div className="space-y-3">
          <p className="text-muted-foreground">
            {isBulk ? (
              <>Are you sure you want to permanently delete <strong>{selectedCount} users</strong>?</>
            ) : (
              <>Are you sure you want to delete <strong>{user?.name}</strong> ({user?.email})?</>
            )}
          </p>
          <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-3">
            <p className="text-red-400 text-sm font-medium">This action cannot be undone!</p>
            <p className="text-red-300 text-xs mt-1">
              {isBulk 
                ? `All data for these ${selectedCount} users will be permanently deleted including accounts, contracts, questions, and credit history.`
                : "All user data will be permanently deleted including:"}
            </p>
            {!isBulk && (
              <ul className="text-red-300 text-xs mt-2 ml-4 list-disc space-y-1">
                <li>User account</li>
                <li>All uploaded contracts</li>
                <li>All questions and answers</li>
                <li>Credit history</li>
              </ul>
            )}
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onDelete}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 disabled:opacity-50 text-foreground rounded-lg transition font-medium"
          >
            {loading ? "Deleting..." : isBulk ? `Yes, Delete ${selectedCount} Users` : "Yes, Delete Permanently"}
          </button>
          <button
            onClick={onClose}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-muted hover:bg-slate-600 disabled:opacity-50 text-foreground rounded-lg transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
